<template>
  <Par />
</template>

<script>
import Par from './par';

export default {
  components: {
    Par
  },
  props: {
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  padding: 0 30px;
  line-height: 40px;
  height: 40px;
}
</style>
